import { isLocalStorageAvailable } from '@ott/utility-localstorage';

export const saveToLocalStorage = (key, value) => {
  if (!isLocalStorageAvailable) {
    return;
  }
  localStorage.setItem(key, value);
};

export const getFromLocalStorage = (key) => {
  if (!isLocalStorageAvailable) {
    return;
  }

  // eslint-disable-next-line consistent-return
  return localStorage.getItem(key);
};

export const removeFromLocalStorage = (key) => {
  if (!isLocalStorageAvailable) {
    return;
  }
  localStorage.removeItem(key);
};
